const handleHamburger = () => {
  const menuTrigger = document.querySelector('.js-menu-trigger');
  const menu = document.querySelector('.js-menu');
  const socials = document.querySelector('.js-trigger');

  menuTrigger.addEventListener('click', () => {
    menuTrigger.classList.toggle('is-active');
    menu.classList.toggle('is-active');
    socials.classList.toggle('is-active');
    document.body.classList.toggle('is-blocked');
  });
};

export default handleHamburger;
